import { Collection } from '@nozbe/watermelondb';

import {
    InventoryChangeModel,
    InventoryChangePayload,
} from '../../../../types/InventoryChange';
import { DBWriterLoggerFunction } from '../../../../types/logger';

export const prepareCreateInventoryChange = ({
    payload,
    userId,
    organisationID,
    collection,
}: {
    payload: InventoryChangePayload;
    userId: string;
    organisationID: string;
    collection: Collection<InventoryChangeModel>;
}) =>
    collection.prepareCreate((inventoryChange) => {
        inventoryChange.inventoryProductId = payload.inventoryProductId;
        inventoryChange.quantityChange = payload.quantityChange;
        inventoryChange.userId = userId;
        inventoryChange.organisationId = organisationID;
        inventoryChange.processAt = payload.processAt;
    });

export const logAddInventoryChangeAction = ({
    inventoryChange,
    logDBAction,
    tableName,
}: {
    inventoryChange: InventoryChangeModel;
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Create inventory change',
        modelName: tableName,
        payload: inventoryChange,
    });
};
